

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    if (lat1 && lon1 && lat2 && lon2) {
        lat1 = radians(lat1);
        lon1 = radians(lon1);
        lat2 = radians(lat2);
        lon2 = radians(lon2);
            
        let dlon = lon2 - lon1;
        let dlat = lat2 - lat1;
        const R = 6371.0;
            
        let a =
          Math.sin(dlat / 2) ** 2 +
          Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) ** 2;
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            
        let distance = R * c;
        return distance;
    } else {
        return null;
    }
  
}

function radians(degrees) {
  return degrees * (Math.PI / 180);
}
